/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tcId: NonNullable<unknown> }} Vehicle_Action_Edit_Tc_Id_DescriptionInputs */

const fr_vehicle_action_edit_tc_id_description = /** @type {(inputs: Vehicle_Action_Edit_Tc_Id_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exemple : https://tc-infos.fr/vehicule/${i?.tcId}.`)
};

const en_vehicle_action_edit_tc_id_description = /** @type {(inputs: Vehicle_Action_Edit_Tc_Id_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Example: https://tc-infos.fr/vehicule/${i?.tcId}.`)
};

/**
* | output |
* | --- |
* | "Example: https://tc-infos.fr/vehicule/{tcId}." |
*
* @param {Vehicle_Action_Edit_Tc_Id_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_edit_tc_id_description = /** @type {((inputs: Vehicle_Action_Edit_Tc_Id_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Edit_Tc_Id_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_edit_tc_id_description(inputs)
	return en_vehicle_action_edit_tc_id_description(inputs)
});